// extracted by mini-css-extract-plugin
module.exports = {"pt-invoice-message":"pt-invoice-message-208ee7a33de321a6afd487a3f8c97d0a"};